import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_YOUTUBE_VIDEOS,
  GET_YOUTUBE_VIDEO_DETAILS,
  CREATE_YOUTUBE_VIDEO,
  UPDATE_YOUTUBE_VIDEO,
  DELETE_YOUTUBE_VIDEO,
} from "./actionTypes"
import {
  getYoutubeVideosFail,
  getYoutubeVideosSuccess,
  getYoutubeVideoDetailsSuccess,
  getYoutubeVideoDetailsFail,
  createYoutubeVideoFail,
  createYoutubeVideoSuccess,
  updateYoutubeVideoSuccess,
  updateYoutubeVideoFail,
  deleteYoutubeVideoSuccess,
  deleteYoutubeVideoFail,
} from "./actions"

import { get, post, ApiPut, del } from "helpers/api_helper"
import { Notification } from "../../components/Common/Notification"

// YoutubeVideo - This line cannot be edited or removed
function getYoutubeVideosAPi({ page, sort, limit, searchText }) {
  return get(
    `/youtube/admin/all/?page=${page ? page : 1}&limit=${
      limit ? limit : 10
    }&search=${searchText}`
  )
}

const getYoutubeVideoDetailsAPi = youtubeVideoId => {
  return get(`/youtube/admin/${youtubeVideoId}`)
}

const createYoutubeVideoApi = ({ youtubeVideo, onCloseClick }) => {
  return post("/youtube/admin/new", youtubeVideo, onCloseClick)
}

const updateYoutubeVideoApi = ({
  youtubeVideo,
  youtubeVideoId,
  onCloseClick,
}) => {
  return ApiPut(`/youtube/admin/${youtubeVideoId}`, youtubeVideo, onCloseClick)
}

const deleteYoutubeVideoApi = ({ youtubeVideoId }) => {
  return del(`/youtube/admin/${youtubeVideoId}`)
}

function* fetchYoutubeVideos({ payload }) {

  try {
    const response = yield call(getYoutubeVideosAPi, payload)
    yield put(getYoutubeVideosSuccess(response))
  } catch (error) {
    yield put(getYoutubeVideosFail(error))
  }
}

function* fetchYoutubeVideoDetails({ payload: youtubeVideoId }) {
  try {
    const response = yield call(getYoutubeVideoDetailsAPi, youtubeVideoId)
    yield put(getYoutubeVideoDetailsSuccess(response))
  } catch (error) {
    yield put(getYoutubeVideoDetailsFail(error))
  }
}

function* onCreateYoutubeVideo({ payload }) {
  try {
    const response = yield call(createYoutubeVideoApi, payload)

    yield put(createYoutubeVideoSuccess(response))
    if (payload?.onCloseClick) {
      payload.onCloseClick()
    }
    doneNotification("Youtube Video Created Successfully!")
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(createYoutubeVideoFail(error))
  }
}

export function* onUpdateYoutubeVideo({ payload }) {
  try {
    const response = yield call(updateYoutubeVideoApi, payload)

    if (response) {
      yield put(updateYoutubeVideoSuccess(response))

      Notification({
        type: "success",
        message: "Youtube Video  Updated Successfully!",
        title: "",
      })

      // Call the modal close callback
      if (payload?.onCloseClick) {
        payload.onCloseClick()
      }
    }
  } catch (error) {
    console.error("Update youtube Video  Error:", error)

    const message =
      error?.response?.data?.message || error?.message || "Something went wrong"

    Notification({
      type: "error",
      message,
      title: "",
    })

    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "File size is too large",
        title: "",
      })
    }

    yield put(updateYoutubeVideoFail(error?.response?.data || { message }))
  }
}
function* onDeleteYoutubeVideo({ payload }) {
  try {
    const response = yield call(deleteYoutubeVideoApi, payload)
    yield put(deleteYoutubeVideoSuccess(response))
    doneNotification("YoutubeVideo Deleted Successfully!")
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    yield put(deleteYoutubeVideoFail(error?.response?.data))
  }
}

function* youtubeSaga() {
  yield takeEvery(GET_YOUTUBE_VIDEOS, fetchYoutubeVideos)
  yield takeEvery(GET_YOUTUBE_VIDEO_DETAILS, fetchYoutubeVideoDetails)
  yield takeEvery(CREATE_YOUTUBE_VIDEO, onCreateYoutubeVideo)
  yield takeEvery(UPDATE_YOUTUBE_VIDEO, onUpdateYoutubeVideo)
  yield takeEvery(DELETE_YOUTUBE_VIDEO, onDeleteYoutubeVideo)
}

export default youtubeSaga

function doneNotification(message) {
  Notification({
    type: "success",
    message: message,
    title: "",
  })
}
